import { CircularProgress, Stack, Typography } from '@mui/material';
import { action, computed, makeObservable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import FerramentasListaProcessos from './FerramentasListaProcessos';
import FerramentasListaProcessosPauta from './FerramentasListaProcessosPauta';
import FerramentasListaProcessosPreSessao from './FerramentasListaProcessosPreSessao';
import ListaProcessos from './ListaProcessos';
import SelecaoProcessos from './SelecaoProcessos';

class PainelProcessos extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            divOverflowScrollTop: action,
            divOverflow: computed,
            reposicionarPagina: action,
            renderFerramentas: computed,
            renderListasProcessos: computed
        });

        this.createReaction(
            reaction(
                () => this.store.processoScroll,
                async (processoScroll) => {
                    if (processoScroll) {
                        this.store.exibirListaProcessos(processoScroll);
                        this.reposicionarPagina(processoScroll);

                        if (this.isSalaSessao) {
                            this.manterFoco(processoScroll);
                        }
                    }
                }
            )
        );
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.divOverflowScrollTop();
    }

    divOverflowScrollTop() {
        if (this.store.offsetScroll[this.store.idProcessosEmExibicao] && this.divOverflow) {
            this.divOverflow.scrollTop =
                this.store.offsetScroll[this.store.idProcessosEmExibicao] * -1 + this.divOverflow.offsetTop;
        }
    }

    manterFoco = (processoScroll) => {
        const focoAtual = document.activeElement;

        if (focoAtual.id.indexOf('idSequencial') > -1) {
            document.getElementById('idSequencial' + processoScroll.numeroProcesso)?.focus();
        } else if (focoAtual.id.indexOf('idAnotacao') > -1) {
            document.getElementById('idAnotacao' + processoScroll.numeroProcesso)?.focus();
        } else if (focoAtual.id.indexOf('idOrdenacaoSecretario') > -1) {
            document.getElementById('idOrdenacaoSecretario' + processoScroll.numeroProcesso)?.focus();
        }
    };

    get divOverflow() {
        const idDivOverflow = 'scrollListaProcessos' + this.store.idProcessosEmExibicao;
        return document.getElementById(idDivOverflow);
    }

    reposicionarPagina(processoScroll) {
        if (processoScroll) {
            setTimeout(() => {
                const idDivProcesso = `${this.store.idProcessosEmExibicao}divProcesso-${processoScroll.numeroProcesso}`;
                const divProcesso = document.getElementById(idDivProcesso);

                if (divProcesso) {
                    this.divOverflow.scrollTop = divProcesso.offsetTop - this.divOverflow.offsetTop - 200;
                }

                runInAction(() => {
                    this.store.processoScroll = undefined;
                });
            }, 10);
        }
    }

    render() {
        return (
            <>
                {this.renderFerramentas}
                {this.sessaoStore.carregandoProcessos || this.store.carregandoProcessos ? (
                    <Stack direction={'row'}>
                        <CircularProgress
                            style={{ margin: '20px' }}
                            disableShrink={true}
                        />
                        <Typography
                            variant="h6"
                            style={{ margin: '25px 10px' }}
                        >
                            Carregando processos...
                        </Typography>
                    </Stack>
                ) : (
                    this.renderListasProcessos
                )}
            </>
        );
    }

    get renderFerramentas() {
        return (
            <>
                {this.routerStore.isSalaSessao && <FerramentasListaProcessos />}
                {this.routerStore.isPreSessao && <FerramentasListaProcessosPreSessao />}
                {this.routerStore.isPautaJulgamento && <FerramentasListaProcessosPauta />}
                <SelecaoProcessos />
            </>
        );
    }

    get renderListasProcessos() {
        return this.store.opcoesProcessosEmExibicao.map((opcao) => (
            <ListaProcessos
                key={opcao.id}
                idListaProcessos={opcao.id}
                processos={opcao.funcaoProcessosFiltrados()}
            />
        ));
    }
}

export default inject('stores')(observer(PainelProcessos));
